import { post } from './requests'

const resourcePath = 'contact_placeholders'

export function createContactPlaceholder (contactPlaceholder) {
  return post(resourcePath, { contact_placeholder: contactPlaceholder })
}
